<template>
  <div class="parent">
    <div class="box">
      <BInputPullDown
        label-name="类型"
        v-model="searchParam.type"
        :Options="pageTypeList"
        placeholder="全部"
      />
      <BInputDateRange
        v-model="createTime"
        from-text="创建时间"
        to-text="至"
        @startDateChange="startDateChange"
        @endDateChange="endDateChange"
      />
      <BInputText
        label-text="关键字"
        v-model="searchParam.mainName"
        placeholder="名称/创建人"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
          <!-- <span v-show="courseStatus !== '03'"> -->
            <BBtnPrimary
              :img-src="require('@/assets/new.png')"
              v-if="editFlag == 'false'"
              :clicked="handleAdd"
              btn-txt="添加章节"
            />
          <!-- </span> -->
        </div>
        <div class="search-result-summary">
          <div class="summary">章节数：{{ courseHourNum }}</div>
          <div class="summary">总时长：{{ courseHoursTimes }}</div>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="pageList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail" @click="handleDetail(item.data.id)">
              详情
            </div>
            <div v-if="item.data.delDisplayFlg === '1'" class="btn-delete" @click="handleDelete(item.data.id)">
              删除
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { searchInit, searchList, deletes } from "@/api/courseLesson";
import BInputPullDown from "../../components2/BInputPullDown";
import BInputText from "../../components2/BInputText";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputDateRange from "../../components2/BInputDateRange";
import Hub from "../../events/Hub";
import PopupContents from "../../views2/sample/PopupContents";
import Vue from "vue";
export default {
  components: {
    Table,
    BInputText,
    BInputPullDown,
    BBtnSecondary,
    BBtnPrimary,
    BInputDateRange,
  },
  data() {
    return {
      headers: [
        { text: "编号", value: "indexNum", sortable: false, align: "center", width: '4%' },
        { text: "章节名称", value: "bbxTrainLessonName", sortable: false,  align: "center", width: '25%' },
        { text: "章节类型", value: "lessonType", sortable: false, align: "center", width: '10%' },
        { text: "创建人", value: "createManName", sortable: false, align: "center", width: '20%' },
        { text: "创建时间", value: "createTime", sortable: false, align: "center", width: '20%' },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      loading: false,
      page: 0,
      totalPages: 0,
      pageNum: 1,
      pageCount: 10,
      totalCount: 0,
      snackbar: false,
      timeout: 3000,
      snackbarColor: "success",
      snackbarText: "",
      data_courseId: "",
      menu: false,
      menu2: false,
      searchParam: {},
      landscape: true,
      pageTypeList: [],
      pageList: [],
      courseHourNum: "",
      courseHoursTimes: "",
      totalCounts: 0,
      deleteId: "",
      deleteDialog: false,
      deleteSuccess: false,
      on: "",
      createTime: {
        from: "",
        to: "",
      },
      data: {},
      // 课程状态
      courseStatus: "",
      editFlag: sessionStorage.getItem("editFlag").toString(),
      navi: [{ name: "course-management" }, { name: "course_lesson" }],
    };
  },
  /* 父子组件传参 data中定义的参数不能与props中定义的参数名一致 */
  props: ["courseId"],
  created() {
    // 页面初期化
    this.comUtils.saveStorage(this.$store);
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 判断是否是从菜单跳至此页面
      const isClear = vm.comUtils.checkUrl(from.name);
      // 如果是从菜单跳过来的 就 清除查询条件
      if (isClear === "true") {
        vm.$store.commit("REMOVE_PAGE_MANAGEMENT_PARAMS");
        // vm.$store.commit('SET_PLAN_EXECUTE_PAGE', 1)
      }
      /* // 查询条件赋值
      vm.searchParam.pageName = vm.$store.state.pageManagement_pageName
      vm.searchParam.pageUrl = vm.$store.state.pageManagement_pageUrl
      if (vm.$store.state.pageManagement_pageKnd !== undefined) {
        vm.searchParam.pageKnd = vm.$store.state.pageManagement_pageKnd
      } */
      // 页面初期化
      vm.init(this.$props.courseId);
      vm.doSearch(true);
    });
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  mounted() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
    if (this.$props.courseId != null && this.$props.courseId != undefined) {
      this.data_courseId = this.$props.courseId;
    }
    this.init(this.data_courseId);
    this.doSearch(true);
  },
  methods: {
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
        this.totalCounts = 0;
      } else {
        // // 查询条件赋值
        // this.searchParam.pageName = this.$store.state.pageManagement_pageName
        // this.searchParam.pageUrl = this.$store.state.pageManagement_pageUrl
        // if (this.$store.state.pageManagement_pageKnd !== undefined) {
        //   this.searchParam.pageKnd = this.$store.state.pageManagement_pageKnd
        // }
      }
      this.searchList();
    },
    async init(id) {
      var param = {
        id: id,
      };
      const data = await searchInit(param);
      this.pageTypeList = data.data.typeList;
      this.courseStatus = data.data.courseStatus;
    },
    async searchList() {
      var param = {
        courseId: this.data_courseId,
        type: this.searchParam.type,
        createTime: this.createTime.from,
        endTime: this.createTime.to,
        mainName: this.comUtils.trim(this.searchParam.mainName),
        page: this.page,
        limit: this.limit,
      };
      const data = await searchList(param);
      if (data.data) {
        this.pageList = data.data.searchList;
        this.courseHourNum = data.data.courseHourNum;
        this.courseHoursTimes = data.data.courseHoursTimes;
        this.totalCounts = data.data.totalCounts;
        this.totalPages = Math.ceil(this.totalCounts / this.limit);
      }
    },
    handleDetail(id) {
      let routeData = this.$router.resolve({
        name: "course_lesson_add",
        query: { courseId: this.data_courseId, lessonId: id, detailFlg: "1" },
      });
      window.open(routeData.href, "_blank");
    },
    handleDelete(id) {
      // if (this.courseStatus === "01") {
        this.data.bodyText = "请确认是否删除该章节？";
        this.deleteId = id;
        Hub.$emit("open-modal");
        Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
      // }
      // if (this.courseStatus === "02") {
      //   this.data.bodyText = "将同步删除该学院的学习记录。确认删除？";
      //   this.deleteId = id;
      //   Hub.$emit("open-modal");
      //   Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
      // }
      // if (this.courseStatus === "03") {
      //   this.data.bodyText = "将同步删除该学院的学习记录和考试记录。确认删除？";
      //   this.deleteId = id;
      //   Hub.$emit("open-modal");
      //   Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
      // }
    },
    set(value) {
      if (value == 1) {
        this.deleteOne();
      }
    },
    async deleteOne() {
      var param = {
        id: this.deleteId,
      };
      const data = await deletes(param);
      if (data.code === 0) {
        this.doSearch(true);
        Vue.prototype.$vsnackbar.show(data.msg);
      } else {
        Vue.prototype.$vsnackbar.show(data.msg);
      }
    },
    handleAdd() {
      let routeData = this.$router.resolve({
        name: "course_lesson_add",
        query: { courseId: this.data_courseId, detailFlg: "0" },
      });
      window.open(routeData.href, "_blank");
    },
    startDateChange(value) {
      this.createTime.from = value;
    },
    endDateChange(value) {
      this.createTime.to = value;
    },
  },
};
</script>

<style scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}

.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.parent {
  margin-top: 1.5em;
}
</style>
